import React, { useRef } from "react";
import TaskList from "./TaskList";
import BulkTaskInput from "./BulkTaskInput";
import plusIcon from "../svg/plus.svg"; // Ensure this path is correct
import { lang } from "../lang";
import { createTask } from "../utils/taskUtils.js"; // This import is crucial

// TaskColumn component for rendering a column of tasks
function TaskColumn({
  level,
  tasks,
  title,
  onAddTask,
  onUpdateTask,
  onDeleteTask,
  onSelectTask,
  selectedPath,
  settings, // Expect the full settings object
}) {
  const isMainColumn = title === lang.taskColumn.mainTasks;
  const parentId = level === 0 ? null : selectedPath[level - 1];
  const taskRefs = useRef({});

  const handleAddMainTask = () => {
    // Use createTask to ensure all defaults, including priority (null by default), are set
    const newTaskData = createTask(
      {
        // This is where 'createTask' is called
        name: lang.task.newTask,
        isNew: true, // Flag for auto-focus
      },
      settings.defaultTaskDuration
    );

    const taskToAdd = { ...newTaskData, isNew: true };

    if (process.env.NODE_ENV === "development") {
      console.log(`[TaskColumn] Adding main task:`, taskToAdd);
    }
    onAddTask(null, taskToAdd); // parentId is null for main tasks

    setTimeout(() => {
      if (
        taskRefs.current[taskToAdd.id] &&
        typeof taskRefs.current[taskToAdd.id].focus === "function"
      ) {
        taskRefs.current[taskToAdd.id].focus();
      }
    }, 0);
  };

  return (
    <div className="column">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h3>
          {isMainColumn ? title : `${lang.taskColumn.subtasksOf} ${title}`}
        </h3>
        {isMainColumn && (
          <button
            className="add-main-task"
            onClick={handleAddMainTask}
            title={lang.app.addMainTask}
          >
            <img src={plusIcon} alt={lang.task.addSubtaskAlt} />
          </button>
        )}
      </div>
      {(isMainColumn ||
        (tasks && tasks.length > 0) ||
        (selectedPath.length > 0 &&
          level > 0 &&
          selectedPath[level - 1] !== undefined)) && (
        <BulkTaskInput
          onAddTask={onAddTask}
          parentId={parentId}
          title={title}
          defaultTaskDuration={settings.defaultTaskDuration}
        />
      )}
      <TaskList
        level={level}
        tasks={tasks}
        settings={settings}
        parentId={parentId}
        onAddTask={onAddTask}
        onUpdateTask={onUpdateTask}
        onDeleteTask={onDeleteTask}
        onSelectTask={onSelectTask}
        selectedPath={selectedPath}
        taskRefs={taskRefs}
      />
    </div>
  );
}

export default TaskColumn;
